;
var app = (function ($, Modernizr) {
    // ANIMATIONS
    var handleAnimations = function () {
        if (($('[data-animation-effect]').length > 0) && !Modernizr.touch) {
            $('[data-animation-effect]').each(function () {
                var item = $(this);
                var animationEffect = item.attr('data-animation-effect');
                if (Modernizr.mq('only all and (min-width: 768px)') && Modernizr.csstransitions) {
                    item.appear(function () {
                        if (item.attr('data-effect-delay')) {
                            item.css('effect-delay', '0ms');
                        }
                        setTimeout(function () {
                            item.addClass('animated object-visible ' + animationEffect);
                        }, item.attr('data-effect-delay'));
                    }, {accX: 0, accY: -130});
                } else {
                    item.addClass('object-visible');
                }
            });
        }
    };

    // STICKIES
    var handleStickies = function () {
        if ($('.sticker').length > 0) {
            if (Modernizr.mq('(min-width: 768px)')) {
                $('.sticker').sticky({
                    topSpacing: 0
                });
            }
        }
    };

    // INIT
    var init = function () {
        handleAnimations();
        handleStickies();
    };

    // API
    return {
        init: init
    };
})(jQuery, Modernizr);
